import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectionComponent implements OnInit {
  lang: 'en' | 'fa' | 'ar' = 'fa';

  @Output() languageChange = new EventEmitter<'en' | 'fa' | 'ar'>();

  constructor() {}

  changeLanguage(lang: 'en' | 'fa' | 'ar'): void {
    this.lang = lang;
    this.languageChange.emit(lang);
  }

  ngOnInit(): void {}
}
